import { AppHelper } from "../appHelper.js";
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp.js";
import { CheckBox } from "../core/components/checkBox.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { FieldInstance } from "../core/components/field.js";
import { Config } from "../core/config/config.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { TeamsInfo } from "./teamsInfo.js";
import { KeyValuePair } from "../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";

export interface GraphTeam extends BaseGraphEntity {
    //channels: GraphChannel[];
    description: string;
    visibility?: string;
}

export interface GraphChannel extends BaseGraphEntity {
    description: string;
    url: string;
}

export interface BaseGraphEntity {
    id: string;
    displayName: string
}

interface InnoBotState {
    initialized: boolean;
    botStatusInfo: BotStatusInfo;
}

export class InnoBot extends React.Component<InnoBotProps, InnoBotState>{
    showExcelButton: boolean = false;
    showSupportButton: boolean = false;
    showMappingsTab: boolean = false;
    private common = new AppHelper();
    private localizations: KeyValuePair<string, string>[];

    constructor(props: InnoBotProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.state = {
            initialized: false,
            botStatusInfo: null,
            //teams: null
        }
        this.initApp();
    }


    private setVisibileConditions = () => {
        this.showExcelButton = this.state.botStatusInfo.allRequiredPermissionsSet;// && false;
        this.showSupportButton = this.state.botStatusInfo.allRequiredPermissionsSet;
        this.showMappingsTab = this.state.botStatusInfo.allSettingsAreSet && this.state.botStatusInfo.allRequiredPermissionsSet && this.state.botStatusInfo.isAppInstalled && (compareVersions(this.props.minVersion, this.state.botStatusInfo.version) != 1);
        this.setState({})
    }

    private initApp = async () => {
        const [isInCatalog, localizations] = await Promise.all([
            HTTPService.get<JsonResultClass<string>>(`InnoBot/CheckBotSettings`),
            HTTPService.get<KeyValuePair<string, string>[]>("InnoBot/GetLocalizations"),
        ])
        this.localizations = localizations;
        this.setState({
            botStatusInfo: JSON.parse(isInCatalog.Data),
            initialized: true
            //teams: teams
        }, this.setVisibileConditions);
    }

    isAppInCatalog = () => {
        return this.state.botStatusInfo;
    }

    private handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    renderTeamsInfo = () => {
        return <TeamsInfo defaultLocation={this.props.context.defaultLocation} localizations={this.localizations} />
    }


    renderAppInstallationInstructions = () => {
        return <AppInstallationInstruction botStatusInfo={this.state.botStatusInfo} minVersion={this.props.minVersion} connectionString={this.props.connectionString} />
    }

    downloadExcel = () => {
        const url = `${Config.baseUrl}InnoBot/Download`
        Helper.openInNewBrowserTab(url);
    }

    getSupportZip = async () => {
        await openDialog();
    }

    componentDidMount() {
        this.common.updateBrowserTitle(Helper.getTranslation("MST.UI.TeamsIntegration"));
        this.common.updateSheetTitle(Helper.getTranslation("MST.UI.TeamsIntegration"));
    }

    render() {
        let appNotInCatalog = null;
        if (!this.state.botStatusInfo) {
            appNotInCatalog = (
                <div style={{ border: "3px solid #d50000", borderWidth: "3px 3px 3px 10px", borderRadius: "4px", padding: "5px", margin: "10px" }}>
                    Innosoft Teams Bot is not installed in Teams catalog. Please install the bot first.
                </div>
            );
        }
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return this.state.initialized ? <>{appNotInCatalog}<CommonApp {...props} /></> : null;
    }
}

const compareVersions = (a: string, b: string) => {
    const a_ok = /^\d{1,2}.\d{1,2}.\d{1,2}$/gm.test(a);
    const b_ok = /^\d{1,2}.\d{1,2}.\d{1,2}$/gm.test(b);

    if (!a_ok || !b_ok)
        return null;

    const numericValue = (value: string) => {
        let result = 0;
        value.split('.').forEach((value, index) => {
            const intValue = parseInt(value);
            result += (intValue * Math.pow(10, 4 - (2 * index)));
        });
        return result;
    }
    const a_value = numericValue(a);
    const b_value = numericValue(b);


    if (a_value > b_value) {
        return 1;
    }

    if (a_value < b_value) {
        return -1;
    }

    return 0;
}

class AppInstallationInstruction extends React.Component<{ botStatusInfo: BotStatusInfo, minVersion: string, connectionString: string }, any>{


    private compareConnectionStrings = () => {

        const split = (connectionString: string) => {
            const arr = connectionString.split(";").map(s => {
                const tmp = s.toLowerCase().trim().split(/=(.*)/s);
                return { Key: tmp[0].toLowerCase().trim(), Value: tmp[1] };
            })
            return {
                dataSource: arr.find(item => item.Key == "data source").Value,
                initialCatalog: arr.find(item => item.Key == "initial catalog").Value
            }
        }

        const c1 = split(this.props.connectionString);
        const c2 = split(this.props.botStatusInfo.connectionString);


        return c1.dataSource == c2.dataSource && c1.initialCatalog == c2.initialCatalog;
    }

    private renderInfo = (labelKey: string, value: boolean) => {
        return (
            <li style={{ display: "flex", color: !value ? "red" : "unset" }} >
                <div style={{ width: "20px" }}>
                    {!value ? <i className="fa-solid fa-xmark"></i> : <i className="fa-solid fa-check"></i>}
                </div>
                {Helper.getTranslation(labelKey)}
            </li>
        );
    }

    private isVersionOk = () => {
        return compareVersions(this.props.minVersion, this.props.botStatusInfo.version) != 1;
    }

    render() {
        const red = "#e53935";
        const green = "#2e7d32";

        let versionMessage = <></>;
        if (this.isVersionOk()) {
            versionMessage = (
                <label style={{ fontSize: "1.1em" }} >
                    {Helper.getTranslation("MST.UI.Setup.CurrentVersion").replace("{x}", this.props.botStatusInfo.version)}
                </label>
            );
        } else {
            versionMessage = (
                <li style={{ fontSize: "1.1em", color: red }} >
                    {Helper.getTranslation("MST.UI.Setup.VersionIsntUptoDate")
                        .replace("{current}", this.props.botStatusInfo.version)
                        .replace("{version}", this.props.minVersion)}
                </li>
            );
        }
        let isConnectionStringMessage = <></>;
        if (!this.compareConnectionStrings()) {
            isConnectionStringMessage = (
                <li style={{ fontSize: "1.1em", color: red }} >
                    {"The connection string of the FSM and the bot do not match"}
                </li>
            );
        }

        const deployInfo = GenerateLabelWithUrl("MST.UI.Setup.DeployInfo", "https://admin.teams.microsoft.com/policies/manage-apps");
        const appIsDeployedInfo = GenerateLabelWithUrl("MST.UI.Setup.AppIsDeployedInfo", `https://admin.teams.microsoft.com/policies/manage-apps/${this.props.botStatusInfo.teamsAppId}`);

        const step1 = (
            <>
                <StepIndicator number={1} titleKey="MST.UI.Setup.ApiSettings">
                    <label style={{ fontSize: "1.2em", color: this.props.botStatusInfo.allSettingsAreSet ? green : red }} >
                        {this.props.botStatusInfo.allSettingsAreSet ? Helper.getTranslation("MST.UI.Setup.MandatorySettingsAreSet") : Helper.getTranslation("MST.UI.Setup.NotMandatorySettingsAreSet")}
                    </label>
                    {GenerateLabelWithUrl("MST.UI.Setup.CreateActiveDirectoryApp", Config.baseUrl + "InnoBot/DownloadActiveDirectoryConfig", "font-size: 1.1em;")}
                    <ul>
                        {this.renderInfo("MST.UI.Setup.ConnectionStringSet", this.props.botStatusInfo.connectionStringDefined)}
                        {this.renderInfo("MST.UI.Setup.ClientIdSet", this.props.botStatusInfo.clientIdDefined)}
                        {this.renderInfo("MST.UI.Setup.ClientSecretSet", this.props.botStatusInfo.clientSecretDefined)}
                        {this.renderInfo("MST.UI.Setup.TenatIdSet", this.props.botStatusInfo.tenantIdDefined)}
                        {this.renderInfo("MST.UI.Setup.BaseUrlSet", this.props.botStatusInfo.baseUrlDefined)}
                        {this.renderInfo("MST.UI.Setup.ExternalAppId", this.props.botStatusInfo.externalAppIdDefined)}
                        {versionMessage}
                        {isConnectionStringMessage}
                    </ul>

                </StepIndicator>
            </>
        );

        let step2 = <></>;
        if (this.props.botStatusInfo.allSettingsAreSet) {
            step2 = (
                <>
                    <StepIndicator number={2} titleKey="MST.UI.Setup.Permissions" >
                        <ActiveDirectoryConfig botStatusInfo={this.props.botStatusInfo} />
                    </StepIndicator>
                </>
            );

        }
        let step3 = <></>;
        if (this.props.botStatusInfo.allSettingsAreSet && this.props.botStatusInfo.allRequiredPermissionsSet) {
            const expiryDate = new Date(this.props.botStatusInfo.expiryDate);
            const diffMonth = Math.floor(moment(expiryDate).diff(moment(new Date()), 'months', true));
            let expireDuration = `${diffMonth} ${Helper.getTranslation("WebSMS.Common.DateTime.Monate")}`;
            if (diffMonth === 0) {
                const diffDays = Math.floor(moment(expiryDate).diff(moment(new Date()), 'days', true));
                expireDuration = `${diffDays} ${Helper.getTranslation("Standard.Tage")}`;
            }

            const expireMessage = Helper.getTranslation("MST.UI.Setup.PasswordExpire").replace("{expireDuration}", expireDuration).replace("{expireDate}", kendo.toString(expiryDate, 'g'));
            step3 = (
                <>
                    <StepIndicator number={3} titleKey="MST.UI.Setup.Installation" >
                        <label style={{ fontSize: "1.2em", color: this.props.botStatusInfo.isAppInstalled ? green : red }} >
                            {this.props.botStatusInfo.isAppInstalled ? Helper.getTranslation("MST.UI.Setup.AppIsInstalled") : Helper.getTranslation("MST.UI.Setup.NotInstalled")}
                        </label>
                        <div> {this.props.botStatusInfo.isAppInstalled ? appIsDeployedInfo : deployInfo} </div>
                        {GenerateLabelWithUrl("MST.UI.Setup.DownloadTeamsApp", Config.baseUrl + "InnoBot/DownloadTeamsApp")}
                        <label>{expireMessage}</label>
                    </StepIndicator>
                </>
            );
        }
        return (
            <>
                {step1}
                {step2}
                {step3}
            </>
        );
    }
}

const GenerateLabelWithUrl = (key: string, url: string, style: string = null) => {
    let styleOptions = "";
    if (!Helper.isNullOrEmpty(style)) {
        styleOptions = `style="${style}"`
    }

    const rawString = Helper.getTranslation(key);
    const arr = rawString.split(/<[\/]{0,1}a>/gm).map(s => s.trim());
    if (arr.length > 1) {
        arr[1] = `<a ${styleOptions} target="_blank" href="${url}">${arr[1]}</a>`
    }
    const html = `<label>${arr.join(" ")}</label>`;
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

class ActiveDirectoryConfig extends React.Component<{ botStatusInfo: BotStatusInfo }, any>{


    private renderPermission = (item: TeamsAppPermission) => {
        return (
            <li style={{ display: "flex", color: !item.hasPermission ? "red" : "unset" }} key={item.id} >
                <div style={{ width: "20px" }}>
                    {!item.hasPermission ? <i className="fa-solid fa-xmark"></i> : <i className="fa-solid fa-check"></i>}
                </div>
                {item.name} {item.hasPermission ? null : ` (${Helper.getTranslation("MST.UI.Setup.ConfirmByAdmin")})`}
            </li>
        );
    }

    render() {
        const permissions = this.props.botStatusInfo.requiredPermissions.map(this.renderPermission);
        return (
            <>
                <label style={{ fontSize: "1.2em", color: this.props.botStatusInfo.allRequiredPermissionsSet ? "#2e7d32" : "#e53935" }} >
                    {this.props.botStatusInfo.allRequiredPermissionsSet ? Helper.getTranslation("MST.UI.Setup.MandatoryPermissions") : Helper.getTranslation("MST.UI.Setup.NotMandatoryPermissions")}
                </label>
                {GenerateLabelWithUrl("MST.UI.Setup.EditAppPermissions", `https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/CallAnAPI/appId/${this.props.botStatusInfo.activeDirectoryAppId}/isMSAApp~/false`)}
                <ul>{permissions}</ul>
            </>
        );
    }
}

interface StepIndicatorProps extends React.PropsWithChildren {
    number: number,
    titleKey: string,
}

class StepIndicator extends React.Component<StepIndicatorProps, any>{
    render() {

        return (
            <div style={{ display: "grid", gridTemplateColumns: "40px auto", gridTemplateRows: "40px auto", marginBottom: "10px" }}>
                <div className="stepNumber" style={{ gridRow: "1/2", gridColumn: "1/2" }} >
                    {this.props.number}
                </div>
                <div style={{ gridRow: "1/2", gridColumn: "2/3", width: "100%", fontWeight: 600, fontSize: "1.2em", display: "flex", alignItems: "center", marginLeft: "10px", lineHeight: "1.5em" }}>
                    {Helper.getTranslation(this.props.titleKey)}
                </div>
                <div style={{ gridRow: "2/3", gridColumn: "2/3", marginLeft: "10px" }} className="stepText">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export interface InnoBotProps extends AppBaseProps {
    entity: InnoBotEntity;
    context: InnoBotContext;
    minVersion: string;
    connectionString: string;
}

interface InnoBotContext extends Context {
    defaultLocation: string;
}

interface InnoBotEntity extends Entity {
    TeamInfos: any[];
    UserInfos: any[];
    BotId: string;
}

interface BotStatusInfo {
    isAppInstalled: boolean;
    teamsAppId: string;
    activeDirectoryAppId: string;
    tenantId: string;
    requiredPermissions: TeamsAppPermission[];
    allRequiredPermissionsSet: boolean;

    connectionStringDefined: boolean;
    clientIdDefined: boolean;
    clientSecretDefined: boolean;
    tenantIdDefined: boolean;
    baseUrlDefined: boolean;
    externalAppIdDefined: boolean;
    allSettingsAreSet: boolean;

    version: string;
    connectionString: string;
    expiryDate: Date;
}

interface TeamsAppPermission {
    id: string;
    name: string;
    hasPermission: boolean;
}

const openDialog = () => {
    return new Promise<void>((resolve) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);

        const onClose = () => {
            targetElement.remove();
            resolve();
        };

        const root = ReactDOM["createRoot"](targetElement[0]);

        root.render(
            <>
                <React.StrictMode>
                    <SupportZipDialog onClose={onClose} />
                </React.StrictMode>
            </>);
    })
}

class SupportZipDialog extends React.Component<{ onClose: () => void }, SupportZipDialogState>{

    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.SupportZip.CreateSupportZip"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Helper.getTranslation("MST.UI.SupportZip.Create"),
                action: () => {
                    this.downloadZip();
                },
                primary: true
            }
        ],
        afterClose: this.props.onClose,
        width: 500
    };

    constructor(props) {
        super(props)
        this.state = {
            appsettings: false,
            logs: true,
            templates: false,
            adaptiveCards: true,
            version: true
        }
    }

    private downloadZip = () => {
        let options = 0;
        options += (this.state.appsettings ? 1 : 0);
        options += (this.state.logs ? 2 : 0);
        options += (this.state.adaptiveCards ? 4 : 0);
        options += (this.state.templates ? 8 : 0);
        options += (this.state.version ? 16 : 0);
        if (options > 0) {
            const url = `${Config.baseUrl}InnoBot/DownloadSupportZip?options=${options}`
            Helper.openInNewBrowserTab(url);
        }
    }

    private renderCheckBox = (key: keyof SupportZipDialogState) => {
        const props = this.factory.getDefaultCheckBoxProps()
        props.value = this.state[key];
        props.onChange = (_, value: boolean) => {
            const state = this.state as SupportZipDialogState;
            state[key] = value;
            this.setState(state)
        }

        return (
            <FieldInstance label={Helper.getTranslation(`MST.UI.SupportZip.${key}`)} noHover={true}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    render() {
        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    {this.renderCheckBox("logs")}
                    {this.renderCheckBox("adaptiveCards")}
                    {this.renderCheckBox("version")}
                    {/*this.renderCheckBox("templates")*/}
                    {this.renderCheckBox("appsettings")}
                </Dialog>
            </>
        );
    }
}

interface SupportZipDialogState {
    appsettings: boolean;
    logs: boolean;
    templates: boolean;
    adaptiveCards: boolean;
    version: boolean;

}